module.exports = __webpack_public_path__ + "img/2011 feuerwehrausflug heimatmuseum 004.a0354748.jpg";